import AdminOrders from "../features/admin/AdminOrders";

function AdminOrdersPage() {
  return (
    <div>
      <AdminOrders></AdminOrders>
    </div>
  );
}

export default AdminOrdersPage;
